export default {
  sm: `
  The everyday values and cultural 
  identities stored and managed 
  securely by DATA CENTER GAK will 
  become the basis for the future 
  generations to understand the life of 
  today.
  `,
  lg: `
  The everyday values and cultural identities stored 
  and managed securely by DATA CENTER GAK will 
  become the basis for the future generations to 
  understand the life of today.
  `,
  xxl: `
  The everyday values and cultural identities stored and managed 
  securely by DATA CENTER GAK will become the basis for the 
  future generations to understand the life of today.
  `,
};
